import { useCertificationsByTeamActiveTableStore } from '../../store/myTeamTableStateStore';
import CertificationsByTeamFilters from '../filters/CertificationsByTeamFilters';
import CertificationsByTeamActiveTable from './CertificationsByTeamActiveTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationsByTeamActiveTab = () => {
  const store = useCertificationsByTeamActiveTableStore();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CertificationsByTeamFilters, {
      store: store
    }), /*#__PURE__*/_jsx(CertificationsByTeamActiveTable, {})]
  });
};
export default CertificationsByTeamActiveTab;